module.exports = __webpack_public_path__ + "img/1.f694d393.webp";